import React, { FC, useContext, useMemo, useState } from "react";
import { Dialog } from "@natera/material/lib/dialog";
import Button from "@natera/material/lib/button";
import "./changeLanguageDialog.scss";
import { APIContext, DialogsContext, EventsContext } from "@app/neva/provider";
import { ActionTypes } from "@app/neva/models";
import { generateActionUserEvent } from "@app/neva/helpers";
import { IntlContext } from "@app/provider";

interface Props {
  onClose: () => void;
}

const ChangeLanguageDialog: FC<Props> = ({ onClose }) => {
  const { userEventHandler } = useContext(EventsContext);
  const {
    apiProviderState: { widgetSettings },
  } = useContext(APIContext);
  const { currentLanguage } = useContext(IntlContext);
  const { menuButtonRef } = useContext(DialogsContext);
  const switchLanguage =
    widgetSettings?.languageConfigs[currentLanguage].widgetPopup.switchLanguage;
  const [continueButton, setContinueButton] =
    useState<HTMLButtonElement | null>(null);

  const focusTrapOptions = useMemo(
    () => ({
      skipInitialFocus: true,
      initialFocusEl: continueButton ?? undefined,
    }),
    [continueButton]
  );

  const handleStayLanguage = () => {
    userEventHandler(
      generateActionUserEvent(ActionTypes.CONTINUE_LANGUAGE_SWITCHING)
    );
    onClose();
    setTimeout(() => {
      menuButtonRef?.current?.focus();
    }, 0);
  };

  const handleCancelSwitch = () => {
    userEventHandler(
      generateActionUserEvent(ActionTypes.CANCEL_LANGUAGE_SWITCHING)
    );
    onClose();
    setTimeout(() => {
      menuButtonRef?.current?.focus();
    }, 0);
  };
  const actions = (
    <>
      <Button onClick={handleCancelSwitch} outlined>
        {switchLanguage?.cancelButtonText}
      </Button>
      <Button ref={setContinueButton} onClick={handleStayLanguage} unelevated>
        {switchLanguage?.continueButtonText}
      </Button>
    </>
  );

  return (
    <Dialog
      className="change-language-dialog"
      onClose={onClose}
      actions={actions}
      title={switchLanguage?.popupTitle}
      focusTrapOptions={focusTrapOptions}
    >
      <div className="dialog-container">{switchLanguage?.popupText}</div>
    </Dialog>
  );
};

export default ChangeLanguageDialog;
